import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import EditSvg from 'assets/icon/edit.svg';
import ListSvg from 'assets/menu-list-icon/list.svg';
import routePaths from 'constants/route-paths';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import { matchPath, useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { getPath } from 'utils/path';
import { GroupListButton, SVGStyled } from '../../style';

type Props = {
  label: string;
  children: ReactNode;
  warning: number;
  residents: number;
  id: string;
  hideEdit: boolean;
  onEdit: () => void;
};

const BoxSubmenu = styled(Box)`
  & .menu-submenu {
    &.has-collapse {
      display: flex;
    }
  }
`;

const EditButton = styled.button`
  outline: none;
  border: none;
  background: none;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.malibu};
  &:hover {
    color: ${(props) => props.theme.colors.eastBay};
  }
`;

const GroupList = ({ label, children, residents = 0, warning, id, hideEdit, onEdit }: Props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const residentPaths = matchPath(location.pathname, {
    path: routePaths.GROUP + routePaths.RESIDENT,
  }) as { params: { residentId: string } };

  const groupPaths = matchPath(location.pathname, {
    path: routePaths.GROUP,
  }) as { params: { groupId: string } };

  const params = {
    residentId: residentPaths?.params?.residentId,
    groupId: groupPaths?.params?.groupId,
  } as { groupId: string; residentId: string };

  const activeState = params?.groupId === id;
  const activeResidentId = !!params?.residentId;

  const onClick = () => {
    if (activeState && !activeResidentId) {
      history.push(routePaths.DASHBOARD);
      return;
    }
    history.push(getPath(routePaths.GROUP, { groupId: id }));
  };

  const onEditClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onEdit();
  };

  return (
    <li
      className={`menu-item menu-item-submenu py-3 p-lg-3 ${
        activeState && 'menu-item-active menu-item-open'
      }`}
    >
      <GroupListButton className="menu-link" onClick={onClick}>
        <SVGStyled active={activeState}>
          <SVG src={ListSvg} />
        </SVGStyled>

        <span className="menu-text">
          <div className={`header ${activeState && 'header-active'}`}>
            {label}
            {activeState && !hideEdit && (
              <EditButton onClick={onEditClick}>
                <SVG src={EditSvg} />
              </EditButton>
            )}
          </div>
          <div className="sub-header">
            {residents} {t('residents')}
          </div>
        </span>
      </GroupListButton>

      <Collapse in={activeState} timeout={500} unmountOnExit={true}>
        <BoxSubmenu>
          <div className="menu-submenu has-collapse">
            <ul className="menu-subnav">{children}</ul>
          </div>
        </BoxSubmenu>
      </Collapse>
    </li>
  );
};

export default GroupList;
